import { baseApiClient } from '../clients';

const FILES_URL = '/files';
baseApiClient.defaults.headers.common['Content-Type'] = 'multipart/form-data';

// @ts-ignore
const uploadFile = (file: File, { onUploadProgress }) => {
  const formData = new FormData();
  formData.append('selectedFile', file);
  return baseApiClient.post(FILES_URL, formData, {
    onUploadProgress: (progressEvent) => {
      // @ts-ignore
      const progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      // Update state here
      onUploadProgress(progress);
    },
  });
};

const deleteFile = (fileHandle: string) => {
  return baseApiClient.delete(`${FILES_URL}/${fileHandle}`);
};

export { uploadFile, deleteFile };
